import { TypographyProps } from '@mui/material'
import { Typography } from 'components/Material/index'
import { lightOnSurfaceVariant } from 'styles/useTextStyles'

interface LabelTextProps extends TypographyProps {
  text: string | number
  typeStyle: 'medium' | 'large' | 'small'
  disabled?: boolean
}

export const LabelText: React.FC<LabelTextProps> = ({ text, typeStyle, disabled, ...props }) => {
  return (
    <Typography sx={styles[typeStyle]} {...props} disabled={disabled}>
      {text}
    </Typography>
  )
}

const styles = {
  large: {
    fontSize: '14px',
    fontFamily: 'BB-Font-Bold',
    lineHeight: '20px',
    letterSpacing: '0.1px'
  },
  medium: {
    fontSize: '12px',
    fontFamily: 'BB-Font-Medium',
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: lightOnSurfaceVariant
  },
  small: {
    fontSize: '11px',
    fontFamily: 'BB-Font-Medium',
    lineHeight: '16px',
    letterSpacing: '0.5px'
  }
}
